var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#D1FADF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#ECFDF3",
    strokeWidth: 9.33333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6668 31.9267V33C44.6654 35.5158 43.8507 37.9638 42.3444 39.9788C40.838 41.9938 38.7207 43.4679 36.3081 44.1812C33.8955 44.8945 31.317 44.8089 28.957 43.937C26.5971 43.0652 24.5823 41.4538 23.2129 39.3432C21.8436 37.2327 21.1933 34.7361 21.3588 32.2257C21.5243 29.7153 22.4969 27.3257 24.1315 25.4133C25.7661 23.5008 27.9751 22.168 30.429 21.6135C32.883 21.0591 35.4505 21.3127 37.7485 22.3367M44.6668 23.6667L33.0002 35.345L29.5002 31.845",
    stroke: "#039855",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrueIcon);
export default __webpack_public_path__ + "static/media/trueIcon.9614eb0376dd8f044078fb526a169226.svg";
export { ForwardRef as ReactComponent };